'use client'

import { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { toast } from 'sonner'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'

interface CopyInputProps {
  value: string
  className?: string
}

export function CopyInput({ value, className }: CopyInputProps) {
  const [copied, setCopied] = useState(false)
  const t = useTranslations('modals.referral')

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      toast.success(t('copy_success'))
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      toast.error(t('copy_failed'))
    }
  }

  return (
    <div
      className={cn(
        'flex items-center gap-2 bg-zinc-900 border border-white/10 rounded-lg overflow-hidden',
        className,
      )}
    >
      <input
        type="text"
        value={value}
        readOnly
        className="flex-1 px-4 py-3 bg-transparent text-white text-sm outline-none"
      />
      <button
        onClick={handleCopy}
        className={cn(
          'px-4 py-3 bg-zinc-800 hover:bg-zinc-700 text-white transition-colors flex items-center gap-2 shrink-0',
          copied && 'bg-green-600 hover:bg-green-600',
        )}
      >
        {copied ? (
          <>
            <Check size={16} />
            <span className="text-sm font-medium">{t('copy_success')}</span>
          </>
        ) : (
          <>
            <Copy size={16} />
            <span className="text-sm font-medium">{t('copy_button')}</span>
          </>
        )}
      </button>
    </div>
  )
}
